import clsx from 'clsx'
import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import * as Yup from 'yup'
import '../masters/basic.css'
import httpService from '../../setup/http/httpServices'
import { Input, message } from 'antd'
import Select from 'react-select'
import loc from '../data/Location.json'
import { AddWebsiteLeftBreadcrum } from './AddWebsiteLeftBreadcrumb'
import { Grid } from '@material-ui/core'
import { toAbsoluteUrl } from '../../_metronic/helpers'

var initialValues = {
  // agencyAssociated: '',
  websiteURL: '',
  AuthorName: '',
  ProfileLink: '',
  price: null,
  // gstNumber: '',
  // companyDescription: '',
  // companyContactPerson: '',
  // companyEmail: '',
  // companyPhoneNumber: '',
  // companyWebsite: '',
  // companyBillingAddress: '',
  // companyCity: '',
  // companyState: '',
  // companyPinCode: '',
}
const regex = /[a-zA-Z]/
const registrationSchema = Yup.object().shape({
  websiteURL: Yup.string()
    .required('URL is required')
    .matches(
      /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
      'Must be a URL'
    ),
  price: Yup.number().required('Price is mandatory'),
  AuthorName: Yup.string().required('Name is required'),
  ProfileLink: Yup.string().required('Link is required'),

  // gstNumber: Yup.string()
  //   .min(15, 'Minimum 15 digits')
  //   .max(15, 'Maximum 15 digits')
  //   .required('GST Number is required'),
  // companyDescription: Yup.string()
  //   .min(3, 'Minimum 3 characters')
  //   .max(500, 'Maximum 500 characters')
  //   .required('Description is required'),
  // companyContactPerson: Yup.string()
  //   .min(3, 'Minimum 3 symbols')
  //   .max(50, 'Maximum 50 symbols')
  //   .required('Contact Person is required')
  //   .matches(/^(?=[^A-Za-z\n]*[A-Za-z])[A-Za-z._-]*[A-Za-z0-9._ -]*$/,"Must be alphanumeric"),
  // companyEmail: Yup.string()
  //   .email('Wrong format of Email')
  //   .matches(
  //     /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  //     'Wrong format of Email'
  //   )
  //   .min(3, 'Minimum 3 symbols')
  //   .max(50, 'Maximum 50 symbols')
  //   .required('Email is required'),
  // companyPhoneNumber: Yup.string()
  //   .min(10, 'Minimum 10 digits')
  //   .max(12, 'Maximum 13 digits with country code')
  //   .required('Phone Number is required'),
  // companyWebsite: Yup.string()
  //   .matches(
  //     /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi,
  //     'Wrong format of URL'
  //   )
  //   .min(3, 'Minimum 3 symbols')
  //   .max(500, 'Maximum 500 symbols')
  //   .required('Website is required'),
  // companyBillingAddress: Yup.string().min(3, 'Minimum 3 symbols').max(500, 'Maximum 500 symbols'),
  // companyPinCode: Yup.string().min(6, 'Minimum 6 digit').max(6, 'Maximum 6 digit'),
})

export function AddWebsiteType() {
  const history: any = useHistory()
  const [loading, setLoading] = useState(false)
  const [websiteType, setWebsiteType] = useState({ id: null, Name: '' })
  const [types, setTypes] = useState([])
  const [isTemplate, setIsTemplate] = useState(false)
  const [frameworks, setFrameworks] = useState([{ value: '', label: 'Select Framework' }])
  const [frameError, setFrameError] = useState(false)
  const [marketError, setMarketError] = useState(false)
  const [marketLink, setMarketLink] = useState('')
  const [frame, setFrame] = useState({ value: null, label: '' })
  const [error, setError] = useState(false)
  const [typeFinal, setTypeFinal] = useState([])
  const isURL = () => {
    try {
      let url = new URL(marketLink)
    } catch (_) {
      return false
    }
    return true
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: isTemplate && registrationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      console.log('idhar', values)
      if (websiteType.id === null) {
        setError(true)
      } else {
        if (isTemplate) {
          console.log('in here')
          if (frame.value === null) setFrameError(true)
          else {
            setLoading(true)

            httpService.patchData(
              '/website/update/?step=2',
              {
                id: history.location.state.id,
                Type: websiteType,
                isTemplate: isTemplate,
                Framework: { id: frame.value, Name: frame.label },
                MarketplaceLink: values.websiteURL,
                Price: values.price,
                AuthorName: values.AuthorName,
                ProfileLink: values.ProfileLink,
              },
              (res) => {
                console.log(res)
                setLoading(false)
                history.push({
                  pathname: '/addWebsite/categories',
                  state: {
                    ...history.location.state,
                    websiteType,
                  },
                })
              },
              (err) => {
                setLoading(false)
                console.log(err)
              }
            )
          }
        } else {
          httpService.patchData(
            '/website/update/?step=2',
            { id: history.location.state.id, Type: websiteType },
            (res) => {
              console.log(res)
              history.push({
                pathname: '/addWebsite/categories',
                state: {
                  ...history.location.state,
                  websiteType,
                },
              })
            },
            (err) => {
              console.log(err)
            }
          )
        }
      }
    },
  })

  const radioChange = (type) => {
    console.log(type)
    const data = { id: type._id, Name: type.Name }

    setWebsiteType(data)
  }
  useEffect(() => {
    setWebsiteType(websiteType)
  }, [websiteType])

  const [nameError, setNameError] = useState(false)

  useEffect(() => {
    console.log(history.location.state)
    httpService.getData(
      '/type-master',
      (res) => {
        console.log(res.data.data.data)
        setTypes(res.data.data.data)
      },
      (err) => {
        message.error('Not able to fetch.')
      }
    )

    setWebsiteType(
      history.location.state?.edit ? history.location.state.website.Type : { id: null, Name: '' }
    )
    setIsTemplate(
      history.location.state?.edit ? history.location.state.website.isTemplate : false
    )
    setFrame(
      history.location.state.website?.Framework
        ? {
          value: history.location.state.website.Framework.id,
          label: history.location.state.website.Framework.Name,
        }
        : { value: null, label: '' }
    )
    formik.setFieldValue('websiteURL', history.location.state.website?.MarketplaceLink || '')
    formik.setFieldValue('price', history.location.state.website?.Price)
    formik.setFieldValue('AuthorName', history.location.state.website?.AuthorName || '')
    formik.setFieldValue('ProfileLink', history.location.state.website?.ProfileLink || '')


  }, [])

  useEffect(() => {
    setError(false)

    if (isTemplate) {
      httpService.getData(
        '/framework-master',
        (res) => {
          console.log(res.data.data.data)
          let x = []
          res.data.data.data.forEach((data) => {
            x.push({ value: data._id, label: data.Name })
          })
          console.log(frameworks)

          setFrameworks(x)
        },
        (err) => {
          message.error('Not able to fetch.')
        }
      )
    }
  }, [isTemplate])
  // const validateName = (name: any) => {
  //   httpService.getData(
  //     '/' + history.location.state?.type.toLowerCase() + '-master/',
  //     (res: any) => {
  //       if (history.location.state?.type == 'Agency') {
  //         htmlFor (var i = 0; i < res.data.data?.agencies.length; i++) {
  //           if (res.data.data?.agencies[i].companyDetails.websiteURL == name) {
  //             setNameError(true)
  //             break
  //           } else {
  //             setNameError(false)
  //           }
  //         }
  //       } else {
  //         htmlFor (var i = 0; i < res.data.data?.brands.length; i++) {
  //           if (res.data.data?.brands[i].companyDetails.websiteURL == name) {
  //             setNameError(true)
  //             break
  //           } else {
  //             setNameError(false)
  //           }
  //         }
  //       }
  //     },
  //     (err: any) => {}
  //   )
  // }

  return (
    <div className='CompanyDetailsOuter '>
      <AddWebsiteLeftBreadcrum currentStep='2' />
      <form
        className=''
        noValidate
        id='kt_login_signup_form'
        onSubmit={formik.handleSubmit}
        style={{ marginBottom: '100px' }}
      >
        <div className='CompanyDetails'>
          <h2 className=''>Website Type</h2>
          {error && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span className='text-danger' role='alert'>
                  {'Type required'}
                </span>
              </div>
            </div>
          )}
          <div className='row pt-4 pe-5 pb-5 ' style={{ height: "25rem", overflowY: "scroll" }}>
            <div className='col '>
              <h6 className='fw-bold required'>Select Website Type</h6>
              {types.map((type) => {
                return (
                  <div className='form-check form-check-custom form-check-solid form-check-sm m-3'>
                    <input
                      className='form-check-input'
                      name='type'
                      type='radio'
                      value=''
                      id={type.Name}
                      onChange={() => radioChange(type)}
                      checked={websiteType.Name === type.Name}
                    />
                    <label className='form-check-label' htmlFor={type.Name}>
                      {type.Name}
                    </label>
                  </div>
                )
              })}
            </div>
          </div>
        </div>

        <div className='CompanyDetails'>
          <h2 className='mb-6'>Template Details</h2>

          <div className='flex' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <h6 className='fw-bold required'>
              Is this a template
            </h6>
            <div className='d-flex align-items-center justify-content-between'>
              <div className='form-check form-check-custom form-check-solid form-check-sm m-3'>
                <input
                  className='form-check-input'
                  name='template'
                  type='radio'
                  id='template-yes'
                  onChange={() => setIsTemplate(true)}
                  checked={isTemplate}
                />
                <label className='form-check-label' htmlFor='template-yes'>
                  Yes
                </label>
              </div>
              <div className='form-check form-check-custom form-check-solid form-check-sm m-3'>
                <input
                  className='form-check-input'
                  name='template'
                  type='radio'
                  id='template-no'
                  onChange={() => setIsTemplate(false)}
                  checked={!isTemplate}
                />
                <label className='form-check-label' htmlFor='template-no'>
                  No
                </label>
              </div>
            </div>

          </div>
          {/* {isTemplate && <div className='separator'></div>} */}
          {isTemplate && (
            <div className='row pt-4 pe-5 pb-5'>
              <h6 className='fw-bold required'>Select Framework</h6>
              <div className='col '>
                <Select
                  isMulti={false}
                  // isDisabled = {history.location.state.id}
                  name='frameworks'
                  value={frame}
                  placeholder='Select Framework'
                  styles={{
                    menuList: (provided, state) => ({
                      ...provided,
                      height: 'auto',
                      maxHeight: '200px',
                    }),
                  }}
                  onChange={(e) => {
                    console.log(e)
                    setFrameError(false)
                    setFrame(e)
                  }}
                  options={frameworks}
                  className={clsx(
                    'text-gray-500 form-control form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect'
                  )}
                />
              </div>
              {frameError && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span className='text-danger' role='alert'>
                      Required!
                    </span>
                  </div>
                </div>
              )}
            </div>
          )}

          {
            isTemplate &&
            <Grid container spacing={2}>
              <Grid item xs={9}>
                <div className='row pt-4 pe-5 pb-5 '>
                  <div className='col '>
                    <h6 className='fw-bold required'>Template  Link</h6>
                    <input
                      type='text'
                      placeholder='Enter Marketplace Link'
                      value={formik.values.websiteURL}
                      onChange={(e) => {
                        formik.setFieldValue('websiteURL', e.target.value)
                      }}
                      className={clsx('form-control form-control-solid border-0 rounded-4 bg-gray-100')}
                    />
                    {formik.errors.websiteURL && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span className='text-danger' role='alert'>
                            {formik.errors.websiteURL}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </Grid>
              <Grid item xs={3}>
                <div className='row pt-4 pe-5 pb-5 '>
                  <div className='col-12 '>
                    <h6 className='fw-bold required'>Price</h6>
                    <Input
                      type='number'
                      placeholder='Enter Price'
                      value={formik.values.price}
                      onChange={(e) => {
                        if (Number(e.target.value) < 0) return;
                        formik.setFieldValue('price', e.target.value)
                      }}
                      className={clsx(
                        'form-control-solid rounded border-0 bg-gray-100 shadow-none',
                        {
                          'is-invalid': formik.touched.price && formik.errors.price,
                        },
                        {
                          'is-valid': formik.touched.price && !formik.errors.price,
                        }
                      )}
                      prefix={
                        <>
                          <span className='fw-bold'>$</span>
                        </>
                      }
                    />
                    {formik.errors.price && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span className='text-danger' role='alert'>
                            {formik.errors.price}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className='row  pe-5 pb-5 '>
                  <div className='col '>
                    <h6 className='fw-bold required'>Author Name</h6>
                    <input
                      type='text'
                      placeholder='Enter name here...'
                      value={formik.values.AuthorName}
                      onChange={(e) => {
                        formik.setFieldValue('AuthorName', e.target.value)
                      }}
                      className={clsx('form-control form-control-solid border-0 rounded-4 bg-gray-100')}
                    />
                    {formik.errors.AuthorName && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span className='text-danger' role='alert'>
                            {formik.errors.AuthorName}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className='row  pe-5 pb-5 '>
                  <div className='col '>
                    <h6 className='fw-bold required'>Author Profile Link</h6>
                    <Input
                      type='text'
                      placeholder='Enter profile link here...'
                      className={clsx(
                        'form-control-solid rounded-4 shadow-none bg-gray-100'
                      )}
                      onChange={(e) => {
                        formik.setFieldValue('ProfileLink', e.target.value)

                      }}
                      value={formik.values.ProfileLink || history.location.state?.website?.ProfileLink}
                      suffix={
                        <>
                          <img src={toAbsoluteUrl('/media/logos/link.svg')} alt='link' />
                        </>
                      }
                    />
                    {formik.errors.ProfileLink && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span className='text-danger' role='alert'>
                            {formik.errors.ProfileLink}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </Grid>
            </Grid>
          }

        </div>


        <div className='d-flex pt-4 pe-5'>
          <button
            type='submit'
            id='kt_sign_up_submit'
            className='btn btn-primary ms-5 CompanyDetailButton'
            onClick={() => {
              console.log('kidhar')
              // history.push({
              //   pathname: '/addWebsite/categories',
              //   state: {
              //     ...history.location.state,
              //   },
              // })
            }}
            disabled={loading}
          // disabled={
          //   formik.isSubmitting ||
          //   !formik.isValid ||
          //   nameError ||
          //   !checkGST(formik.values.gstNumber)
          // }
          >
            {!loading && <span className='indicator-label'>Next</span>}
            {loading && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
            {/* <span className='indicator-label'>Next</span> */}
          </button>
          <Link
            to={{
              pathname: '/addWebsite',
              state: history.location.state,
            }}
          >
            <button type='button' className='btn fw-bolder btn-gray-200 ms-5 CompanyDetailButton'>
              Back
            </button>
          </Link>
        </div>
      </form>
    </div>
  )
}
